<template>
	<ProductsGrid />
	<Section title="Best Seller" type="best_seller" />
	<Section title="Featured" type="featured" />
	<Section title="Top Liked" type="top_liked" />
	<Section title="New Arrivals" type="new_arrival" />
</template>

<script>
	import Section from "./Section.vue";
	import ProductsGrid from "./Grid/ProductsGrid.vue";
	export default {
		components: {Section, ProductsGrid},
	};
</script>

<style></style>
